
import { defineComponent, onMounted, ref } from 'vue';
import { useDeviceSize } from 'SharedDir/common/composables/useDeviceSize';
import { makeRequest } from 'SharedDir/common/composables/useRequests';
import { ServiceGroupsApi } from 'SharedDir/backend/api';
import SidebarItem from 'PortalDir/modules/Services/components/SidebarItem.vue';
import { paramsAllRequest } from 'SharedDir/backend/api/default-params';

export default defineComponent({
  name: 'ServiceSidebar',
  components: { SidebarItem },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const { isMobile } = useDeviceSize();

    const list = ref<any>([]);

    const getPublicServiceGroupList = async () => {
      const response = await makeRequest(() => ServiceGroupsApi.getAllPublicList(paramsAllRequest));
      if (response) {
        list.value = response;
      }
    };

    function close() {
      emit('update:modelValue', false);
    }

    onMounted(async () => {
      await getPublicServiceGroupList();
    });

    return { props, list, isMobile, close };
  },
});
